import request from '@/utils/request'
import qs from 'qs'
import Cookies from 'js-cookie'

/**
 * 每日登录统计
 *
 * 数据来自后端 tb_user_daily_login（每人每天一条）。
 * 注意：只从功能上线那天开始有数据，历史登录没有留痕，不会回填。
 */

/** 汇总卡片：昨日 / 近7日 / 本月 / 上月 */
export function getDailyLoginSummary () {
  return request({
    url: '/user/daily-login/summary',
    method: 'get'
  })
}

/** 每日走势：按天返回总登录/新注册/老用户 + 各设备人数 */
export function getDailyLoginTrend (params) {
  return request({
    url: '/user/daily-login/trend',
    method: 'get',
    params
  })
}

/** 某天登录的会员分页列表 */
export function getDailyLoginMembers (params) {
  return request({
    url: '/user/daily-login/members',
    method: 'get',
    params
  })
}

/**
 * 导出某天登录的会员。
 * 与订单导出一致：拼出带 token 的下载地址，交给浏览器直接下载。
 */
export function buildDailyLoginExportUrl (params = {}) {
  const query = qs.stringify({
    token: Cookies.get('token'),
    ...params
  })
  return `${process.env.VUE_APP_API_TARGET}${process.env.VUE_APP_BASE_API}/user/daily-login/members/export?${query}`
}

/** 设备来源字典 */
export const DEVICE_SOURCE_MAP = {
  h5: 'H5',
  android: '安卓',
  ios: 'iOS',
  unknown: '未知'
}
